import { createContext } from 'react';

import { Store, createStore } from '../../../core/store/store.js';
import { TreeMapState } from '../types/state.js';

export const initialTreeMapState: TreeMapState = {
  groupsSelected: [],
  highlightedItem: undefined,
  hierarchyLeafNodes: [],
  hierarchyClusterNodes: [],
  colorMap: new Map(),
};

export const TreeMapStateContext = createContext<Store<TreeMapState>>(
  createStore<TreeMapState>(initialTreeMapState),
);
